const NormalizationConstants = {
  /*
   * These are used to normalize the upgrade cost, number of units, and rent inputs
   */
  maxTitleLength: 40,
  maxAddressLength: 200,
  maxCity: 50,
  maxPostalCode: 8,
  maxDollarLength: 10,
};

export default NormalizationConstants;
